import i18n from 'i18next';

export const SELECT_AGE_OPTIONS = [
	{ name: i18n.t('parental_control_no_age_limits'), value: 0 },
	{ name: i18n.t('parental_control_seven_age_limits'), value: 7 },
	{ name: i18n.t('parental_control_twelve_age_limits'), value: 12 },
	{ name: i18n.t('parental_control_sixteen_age_limits'), value: 16 },
	{ name: i18n.t('parental_control_eighteen_age_limits'), value: 18 }
];
